var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { all_schools, propertyStatus, tabId } = options; 
__p+='\n';
 let schoolRatingColor = '' 
__p+='\n';
 let tabName = tabId.split('-')[1] 
__p+='\n';
 if (all_schools && all_schools.length) { 
__p+='\n  <table class="table table-clear table-heading-unstyled table-school school-rating-lg">\n      <thead>\n        <tr>\n          <th class="score text-left"> Rating* </th>\n          <th class="name text-left"> School Name </th>\n          <th class="grades text-center hidden-qv-xs"> Grades </th>\n          <th class="distance hidden-qv-xs text-center"> Distance </th>\n        </tr>\n      </thead>\n      <tbody>\n        ';
 all_schools.map((school, index) => { 
__p+='\n          ';
 if (school.rating > 7) { 
__p+='\n            ';
 schoolRatingColor = 'school-rating-dark-green'; 
__p+='\n          ';
 } 
__p+='\n          ';
 if (school.rating > 4 && school.rating < 8) { 
__p+='\n            ';
 schoolRatingColor = 'school-rating-green'; 
__p+='\n          ';
 } 
__p+='\n          ';
 if (school.rating < 5) { 
__p+='\n            ';
 schoolRatingColor = 'school-rating-light-green'; 
__p+='\n          ';
 } 
__p+='\n          ';
 if (!school.rating) { 
__p+='\n            ';
 schoolRatingColor = 'school-rating-grey'; 
__p+='\n          ';
 } 
__p+='\n          <tr>\n            <td class="score text-left">\n              <span class="school-rating-qv '+
((__t=(schoolRatingColor ))==null?'':__t)+
'">\n                ';
 if (school.rating != undefined ) { 
__p+='\n                    <span class="school-rating-text">'+
((__t=( school.rating ))==null?'':__t)+
'</span>/10\n                ';
 } else { 
__p+='\n                  NR\n                ';
 } 
__p+='\n              </span>\n            </td>\n            <td class="name text-left">\n              <a target="_blank" data-omtag="'+
((__t=(propertyStatus))==null?'':__t)+
':ldp_quickview:schools_'+
((__t=(tabName))==null?'':__t)+
':pos_'+
((__t=(index+1))==null?'':__t)+
'" href="'+
((__t=( `/local/schools/${school.slug}` ))==null?'':__t)+
'">\n                '+
((__t=( school.name ))==null?'':__t)+
'\n              </a>\n            </td>\n            <td class="grades hidden-qv-xs text-center">\n              '+
((__t=( school.grades_display ))==null?'':__t)+
'\n            </td>\n            <td class="distance hidden-qv-xs text-center">\n              '+
((__t=( school.distance ))==null?'':__t)+
'\n            </td>\n          </tr>\n        ';
}) 
__p+='\n      </tbody>\n  </table>\n  <p class="fine-print margin-left link-tertiary margin-top-lg text-left">\n    <span class="margin-left-sm">\n      <span class="pull-left">*</span>School data provided by National Center for Education Statistics, Pitney Bowes, and <a href="https://www.greatschools.org/" rel="nofollow noopener noreferrer" target="_blank">GreatSchools</a>. Intended for reference only. The GreatSchools Rating is based on a variety of school quality indicators, including test scores, college readiness, and equity data. To verify enrollment eligibility, contact the school or district directly.\n    </span>\n  </p>\n';
 } else { 
__p+='\n  <p class="text-left">Contact an agent for Schools Information.</p>\n';
 } 
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/schools/qv-sec-schools-item.jst.ejs